import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { scopeCustomCode } from "../../utils/builderUtils";
import { buildTextStylesheet } from "./ElementTextStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";

const ElementText = (props) => {
  let element = props.element;
  const stylesheet = buildTextStylesheet(
    props.builder,
    props.device,
    props.cta,
    element,
    props.variant
  );

  return (
    <React.Fragment>
      <div
        id={"element" + element.id + "-content"}
        className="element-content cf-text-element cf-margin-alignment cf-merge-tag-allowed"
        data-font={`${element.options["font-family"] || ""} ${
          element.options["font-family-mobile"] || ""
        }`}
        dangerouslySetInnerHTML={{
          __html:
            props.builder == true
              ? "<div class='froala-editor'>" +
                scopeCustomCode(element.html, `#cta_${props.cta.id}`) +
                "</div>"
              : element.html,
        }}
      ></div>
      <BuilderStyleTag
        builder={props.builder}
        styleKey={`cta:${props.cta.id}:element:${element.id}:text`}
        stylesheet={stylesheet}
      />
    </React.Fragment>
  );
};

export default ElementText;
